import Vue from 'vue';
import VueRouter from 'vue-router';

import Home from './views/Home.vue';
import Admin from './views/Admin.vue';
import Login from './views/Login.vue';
import Book from './views/Book.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    component: Home,
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
  },
  {
    path: '/:id',
    redirect: '/:id/book'
  },
  {
    path: '/:id/admin',
    name: 'admin',
    component: Admin,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/:id/book',
    name: 'book',
    component: Book,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/:id/add',
    name: 'add',
    component: Book,
    meta: {
      requiresAuth: true,
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const urlJwt = urlParams.get('token');

    if (urlJwt) {
      localStorage.setItem('jwt', urlJwt);
    }

    if (localStorage.getItem('jwt') == null) {
      next({
        path: '/login',
        // query: { nextUrl: to.fullPath },
      });
    } else {
      next({
        query: null,
      });
    }
  } else {
    next();
  }
});

export default router;
